<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/moje-sprawy' aria-label='E-usługi'>Moje sprawy</a>
    </li>
    <li>
      {{ loading() ? 'Ładowanie danych...' : (case()?.caseNumber || 'Szczegóły sprawy') }}
    </li>
  </app-breadcrumbs>
  @if (!loading()) {
    <section class="my-case-details">
      <h2>
        Sprawa:&nbsp;{{ case()?.caseNumber || 'Brak numeru' }}
      </h2>
      <div class="gov-card">
        <div class="gov-card__body">
          <div class="row">
            <div class="col-12">
              <app-label label="Dotyczy:">
                {{ case()?.concerns || '-' }}
              </app-label>
            </div>
            <div class="col-12">
              <app-label label="Status:">
                {{ case()?.status?.name || 'Nieznany' }}
              </app-label>
            </div>
            <div class="col-12">
              <app-label label="Data utworzenia:">
                {{ (case()?.createdAt | date) || 'Brak danych' }}
              </app-label>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div>
        <app-alert class="d-inline-block" [closable]="false" type="info">
          W celu dalszej korespondencji należy w ramach tej sprawy należy przejść do jednej z poniższych e-usług.
        </app-alert>
        <br>
        @for (item of services(); track $index) {
          <button type="button" class="btn btn-primary me-4 mb-2"
                  [state]="{ fromCase: case()?.caseNumber || 'Brak numeru' }"
                  [routerLink]="'/e-uslugi' + item.url + '/skladanie-wniosku'">{{ item.name }}
          </button>
        }
      </div>
      <br>
      <h3>
        Korespondencja dotycząca sprawy
      </h3>
      <br>
      <form novalidate #form="ngForm">
        <div class="form-group">
          <div class="custom-radio custom-inline">
            <input name="shipmentType" [(ngModel)]="shipmentType" type="radio" id="all_radio" value="all">
            <label for="all_radio">Wszystkie</label>
          </div>
          <div class="custom-radio custom-inline">
            <input name="shipmentType" [(ngModel)]="shipmentType" type="radio" id="incoming_radio" value="incoming">
            <label for="incoming_radio">Przychodząca</label>
          </div>
          <div class="custom-radio custom-inline">
            <input name="shipmentType" [(ngModel)]="shipmentType" type="radio" id="outgoing_radio" value="outgoing">
            <label for="outgoing_radio">Wychodząca</label>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-md-12">
          <ul class='item-list'>
            @for (item of shipments() | myCasesFilter: shipmentType; track $index) {
              <li>
                <div>
                  <a
                    [routerLink]='"/moje-sprawy/" + case()?.uuid + "/pismo/" + item.uuid'>
                    {{ item.concerns || 'Szczegóły pisma' }}&nbsp;
                    @if (shipmentType === 'all') {
                      <small>
                        <small>({{ item.incoming ? 'Przychodzące' : 'Wychodzące' }})</small>
                      </small>
                    }
                  </a>
                  @if (item?.incoming && !item?.confirmations?.length) {
                    <span class="ms-1 color--light-red">
                      <i aria-hidden="true" class="fa fa-envelope me-2 ms-1"></i>
                      <small style="margin-bottom: 0.15rem">(nie odebrane)</small>
                    </span>
                  }
                </div>
                @if (item.incoming) {
                  <div>
                    <small>
                      Data otrzymania: <strong>{{ item?.createdAt | date: 'dd.MM.yyyy HH:mm' }}</strong>
                    </small>
                    &nbsp;
                    <small>
                      Nr pisma: <strong>{{ item?.rkwNumber || '-' }}</strong>
                    </small>
                  </div>
                } @else {
                  <div>
                    <small>
                      Data wysłania: <strong>{{ item?.createdAt | date: 'dd.MM.yyyy HH:mm' }}</strong>
                    </small>
                    &nbsp;
                    <small>
                      Nr pisma: <strong>{{ item?.rpwNumber || '-' }}</strong>
                    </small>
                  </div>
                }
              </li>
            }
          </ul>
          @if (!shipments().length) {
            <app-alert [closable]='false'>Brak pism przypisanych do sprawy!</app-alert>
          } @else if (!(shipments() | myCasesFilter: shipmentType)?.length) {
            <app-alert alertContent='Brak wyników!' [closable]='false'></app-alert>
          }
        </div>
      </div>
    </section>
  } @else {
    <app-spinner>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  }
</app-content>
